import { groupBy, GroupedObservable } from 'rxjs/operator/groupBy';
import { mergeMap } from 'rxjs/operator/mergeMap';
import { exhaustMap } from 'rxjs/operator/exhaustMap';
import { map } from 'rxjs/operator/map';
import { dematerialize } from 'rxjs/operator/dematerialize';
import { filter } from 'rxjs/operator/filter';
import { concat } from 'rxjs/observable/concat';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { Notification } from 'rxjs/Notification';
import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { EffectNotification, verifyOutput } from './effect_notification';
import { getSourceForInstance } from './effects_metadata';
import { resolveEffectSource } from './effects_resolver';
import { ErrorReporter } from './error_reporter';
export class EffectSources extends Subject<any> {
/**
 * @param {?} errorReporter
 */
constructor(private errorReporter: ErrorReporter) {
    super();
  }
/**
 * @param {?} effectSourceInstance
 * @return {?}
 */
addEffects(effectSourceInstance: any) {
    this.next(effectSourceInstance);
  }
/**
 * @return {?}
 */
toActions(): Observable<Action> {
    return mergeMap.call(
      groupBy.call(this, getSourceForInstance),
      (source$: GroupedObservable<any, any>) =>
        dematerialize.call(
          filter.call(
            map.call(
              exhaustMap.call(source$, resolveEffectSource),
              (output: EffectNotification) => {
                verifyOutput(output, this.errorReporter);

                return output.notification;
              }
            ),
            (notification: Notification<any>) => notification.kind === 'N'
          )
        )
    );
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ErrorReporter, },
];
}

function EffectSources_tsickle_Closure_declarations() {
/** @type {?} */
EffectSources.decorators;
/**
 * @nocollapse
 * @type {?}
 */
EffectSources.ctorParameters;
/** @type {?} */
EffectSources.prototype.errorReporter;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}



// WEBPACK FOOTER //
// ../../../modules/effects/src/effect_sources.ts